import { CartErrorEvent, CartLinesUpdateEvent } from '@shopify/events';

function cartSectionIds() {
  return [
    ...new Set(
      [...document.querySelectorAll('cart-items-component[data-section-id]')]
        .map((component) => component.dataset.sectionId)
        .filter(Boolean)
    ),
  ];
}

async function fetchCart() {
  const component = document.querySelector('cart-items-component');

  if (component) {
    await customElements.whenDefined('cart-items-component');
    if (typeof component.fetchCartData === 'function') return component.fetchCartData();
  }

  const response = await fetch(`${Theme.routes.cart_url}.json`, {
    headers: { Accept: 'application/json' },
    credentials: 'same-origin',
  });

  if (!response.ok) throw new Error(`Failed to fetch cart: ${response.status}`);
  return response.json();
}

async function openCart() {
  if (window.Shopify?.actions?.openCart) {
    await window.Shopify.actions.openCart();
    return;
  }

  const drawer = document.querySelector('theme-drawer#cart-drawer');
  if (typeof drawer?.open === 'function') {
    drawer.open();
    return;
  }

  window.location.assign(Theme.routes.cart_url || '/cart');
}

async function addItems({ items, target = document, context = 'product', sourceId = '', open = true }) {
  if (!Array.isArray(items) || items.length === 0) throw new Error('No cart items supplied');

  const sections = cartSectionIds();
  const eventPromise = CartLinesUpdateEvent.createPromise();
  const lines = items.map((item) => ({
    merchandiseId: String(item.id),
    quantity: Number(item.quantity) || 1,
  }));

  target.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context,
      lines,
      promise: eventPromise.promise,
    })
  );

  try {
    const response = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items,
        sections: sections.join(','),
        sections_url: window.location.pathname,
      }),
    });
    const responseData = await response.json();

    if (!response.ok || responseData.status) {
      throw new Error(responseData.description || responseData.message || 'Add to cart failed');
    }

    const cart = await fetchCart();
    eventPromise.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        sections: responseData.sections,
        items: cart.items,
        itemCount: cart.item_count,
        source: 'oudie-cart-add',
        sourceId,
        didError: false,
      },
    });

    if (open) await openCart();
    return cart;
  } catch (error) {
    eventPromise.reject(error);
    target.dispatchEvent(
      new CartErrorEvent({
        error: error?.message || 'Add to cart failed',
        code: 'INVALID',
      })
    );
    throw error;
  }
}

window.OudieCart = { addItems };

